<div class="field-container" [formGroup]="group">
  <label class="field-label" [for]="config.name">{{ config.label }}</label>
  <div class="field-row">
    <ng-container *ngIf="formConfig.showIcons">
      <div class="icon-container">
        <mat-icon
          fontSet="material-icons-outlined"
          [attr.aria-label]="config.label"
          aria-hidden="false"
        >
          {{ config.icon }}
        </mat-icon>
      </div>
    </ng-container>
    <input
      [id]="config.name"
      [name]="config.name"
      [type]="config.fieldConfig.inputType"
      [formControlName]="config.name"
      [placeholder]="config.placeholder"
      [autocomplete]="config.fieldConfig.autocomplete"
      [required]="config.required"
    />
  </div>
  <ng-container *ngIf="formControl?.errors; else padding">
    <span
      class="error-container"
      [ngStyle]="{ visibility: formControl.touched ? 'inherit' : 'hidden' }"
    >
      {{ formControl?.errors | formError }}
    </span>
  </ng-container>
  <ng-template #padding>
    <span class="error-padding"></span>
  </ng-template>
</div>
